import React from "react"

import { Switch, Route } from "client/components"
import * as routes from "client/parts/routes"

import Details from "client/pages/project/project/view/details"
import ProjectGroup from "client/pages/project/groups"
import ProjectUser from "client/pages/project/users/assigned"
import ProjectPermissions from "client/pages/project/permissions"

import Settings from "client/pages/settings"
import Task from "client/pages/task"
import Drive from "client/pages/drive"

import CcLibrary from "client/pages/cc/library"
import CcCompliance from "client/pages/cc/compliance"
import CcReview from "client/pages/cc/review"
import CcRequirement from "client/pages/cc/requirement"
import CcRequirementReview from "client/pages/cc/requirementReview"

import Lifecycle from "client/pages/lifecycle"

import SilDevice from "client/pages/sil/device"
import SilSafetyFunction from "client/pages/sil/safetyFunction"
import SilResults from "client/pages/sil/results"
import SilCalculationAssumptions from "client/pages/sil/calculationAssumptions"

import RrsCategory from "client/pages/rrs/category"
import RrsTemplate from "client/pages/rrs/template"

import Study from "client/pages/study/study"
import StudySession from "client/pages/study/session"

import Reporting from "client/pages/reporting"

const ProjectContent = () => (
    <Switch>
        <Route path={`${routes.projectBaseRoute}${routes.projectDetailsRoute}`} component={Details} />
        <Route path={`${routes.projectBaseRoute}${routes.projectGroupsRoute}`} component={ProjectGroup} />
        <Route path={`${routes.projectBaseRoute}${routes.projectUsersRoute}`} component={ProjectUser} />
        <Route path={`${routes.projectBaseRoute}${routes.projectPermissionsRoute}`} component={ProjectPermissions} />
        <Route path={`${routes.projectBaseRoute}${routes.projectSettingsRoute}`} component={Settings} />

        <Route path={`${routes.projectBaseRoute}${routes.tasksRoute}`} component={Task} />
        <Route path={`${routes.projectBaseRoute}${routes.driveRoute}`} component={Drive} />

        <Route path={`${routes.projectBaseRoute}${routes.projectCcComplianceRoute}`} component={CcCompliance} />
        <Route path={`${routes.projectBaseRoute}${routes.projectCcReviewRoute}`} component={CcReview} />
        <Route path={`${routes.projectBaseRoute}${routes.projectCcRequirementsRoute}`} component={CcRequirement} />
        <Route path={`${routes.projectBaseRoute}${routes.projectCcRequirementsReviewRoute}`} component={CcRequirementReview} />
        <Route path={`${routes.projectBaseRoute}${routes.ccComplianceSetsRoute}`} component={CcLibrary} />

        <Route path={`${routes.projectBaseRoute}${routes.lifecyclesRoute}`} component={Lifecycle} />

        <Route path={`${routes.projectBaseRoute}${routes.silDevicesRoute}`} component={SilDevice} />
        <Route path={`${routes.projectBaseRoute}${routes.silSubsystemsRoute}`} component={SilDevice} />
        <Route path={`${routes.projectBaseRoute}${routes.silSafetyFunctionsRoute}`} component={SilSafetyFunction} />
        <Route path={`${routes.projectBaseRoute}${routes.silResultsRoute}`} component={SilResults} />
        <Route path={`${routes.projectBaseRoute}${routes.silCalculationAssumptionsRoute}`} component={SilCalculationAssumptions} />

        <Route path={`${routes.projectBaseRoute}${routes.markovRoute}`} component={Markov} />

        <Route path={`${routes.projectBaseRoute}${routes.rrsCategoriesRoute}`} component={RrsCategory} />
        <Route path={`${routes.projectBaseRoute}${routes.rrsTemplatesRoute}`} component={RrsTemplate} />

        <Route path={`${routes.projectBaseRoute}${routes.studiesRoute}`} component={Study} />
        <Route path={`${routes.projectBaseRoute}${routes.studySessionsRoute}`} component={StudySession} />

        <Route path={`${routes.projectBaseRoute}${routes.reportingRoute}`} component={Reporting} />
    </Switch>
)
export default ProjectContent


const Markov = () => (<div>Markov</div>)
